<template lang="pug">
	.load
		.load__spinner
			.load__spinner-item
			.load__spinner-item
			.load__spinner-item
</template>

<script>
export default {
	name:     'pre-load',
};
</script>
